import { MMKV } from 'react-native-mmkv';

const storage = new MMKV();

export default {
  getStorage: () => storage,
  setItem: (key: string, value: boolean | string | number | ArrayBuffer) => {
    storage.set(key, value);

    return Promise.resolve(true);
  },
  getItem: (key: string) => {
    const value = storage.getString(key);

    return Promise.resolve(value);
  },
  removeItem: (key: string) => {
    storage.delete(key);

    return Promise.resolve();
  },
};
